import React from "react";
import ValueDisplay from "../ValueDisplay/ValueDisplay";
import { IAudienceMember } from "../../../features/compliance/interfaces";

interface MemberViewProps {
	selectedMember: IAudienceMember | undefined;
}

const MemberView: React.FC<MemberViewProps> = ({ selectedMember }) => {
	if (!selectedMember) return null;
	return (
		<div className="grid grid-cols-3 col-span-9 gap-4 mb-5">
			<div>
				<div className="font-bold text-primary">Member</div>
				<ValueDisplay title="Name" value={`${selectedMember?.firstName} ${selectedMember?.lastName}`} />
				<ValueDisplay title="Phone" value={selectedMember?.contactJObject?.Phones?.length ? selectedMember?.contactJObject?.Phones[0].Phone : null} />
				<ValueDisplay title="Email" value={selectedMember?.emailAddress} />
				<ValueDisplay title="Application" value={selectedMember?.applicationName} />
				<ValueDisplay title="Login ID" value={selectedMember?.loginId} />
				<ValueDisplay title="User Class" value={selectedMember?.memberTypeName} />
			</div>
			<div>
				<div className="font-bold text-primary">Office</div>
				<ValueDisplay title="Name" value={selectedMember?.contactJObject?.ContactOffices?.length ? selectedMember?.contactJObject?.ContactOffices[0].Office?.Name : null} />
				<ValueDisplay title="Phone" value={selectedMember?.contactJObject?.ContactOffices[0].Office?.Phone} />
				<ValueDisplay title="Address" value={selectedMember?.contactJObject?.ContactOffices[0].Office?.Address1} />
				<ValueDisplay title="Code" value={selectedMember?.contactJObject?.ContactOffices[0].Office?.OfficeCode} />
			</div>
			<div>
				<div className="font-bold text-primary">Aor</div>
				<ValueDisplay title="Name" value={selectedMember?.aorName} />
				<ValueDisplay title="Phone" value={selectedMember?.contactJObject?.ContactAors?.length ? selectedMember?.contactJObject?.ContactAors[0].Aor?.Phone : null} />
				<ValueDisplay title="Address" value={selectedMember?.contactJObject?.ContactAors?.length ? selectedMember?.contactJObject?.ContactAors[0].Aor?.Address1 : null} />
			</div>
		</div>
	);
};

export default MemberView;
